module.exports = __webpack_public_path__ + "ui-static/img/not-found-items_light.2c299b14.svg";